import React, { useState, useEffect } from 'react';
import sanityClient from '../lib/sanityClient';

function NewsPage() {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 9;

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "news"] | order(publishedAt desc) {
          _id,
          title,
          "date": publishedAt,
          categories,
          "image": mainImage.asset->url,
          slug,
          featured
        }`
      )
      .then((data) => {
        // Format dates
        const formattedArticles = data.map((article) => ({
          ...article,
          date: article.date
            ? new Date(article.date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })
            : 'No date',
        }));

        setArticles(formattedArticles);
        setFilteredArticles(formattedArticles);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching news articles:', err);
        setError('Failed to load news. Please try again later.');
        setIsLoading(false);
      });
  }, []);

  // Filter articles by category
  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredArticles(articles);
    } else {
      const filtered = articles.filter(
        (article) => article.categories && article.categories.includes(activeCategory)
      );
      setFilteredArticles(filtered);
    }
    // Reset to first page when filter changes
    setCurrentPage(1);
  }, [activeCategory, articles]);

  // Get all unique categories from articles
  const allCategories = Array.from(
    new Set(articles.flatMap((article) => article.categories || []))
  );

  // Pagination
  const indexOfLastArticle = currentPage * articlesPerPage;
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);

  if (isLoading) {
    return (
      <div className="bg-black min-h-screen flex justify-center items-center">
        <div className="text-white text-xl">Loading news articles...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-black min-h-screen flex justify-center items-center">
        <div className="bg-gray-900 p-6 rounded-lg text-white text-xl">{error}</div>
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen pb-12">
      {/* News Header */}
      <div className="relative h-[200px] bg-gradient-to-b from-gray-900 to-black flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
          <h1 className="text-4xl md:text-5xl font-bold text-white">News</h1>
          <div className="mt-4 flex flex-wrap space-x-2">
            <button
              className={`px-4 py-2 rounded-md text-sm font-medium mb-2 ${
                activeCategory === 'all'
                  ? 'bg-yellow-600 text-white'
                  : 'bg-gray-800 text-gray-400 hover:text-white'
              }`}
              onClick={() => setActiveCategory('all')}
            >
              ALL NEWS
            </button>
            {allCategories.map((category) => (
              <button
                key={category}
                className={`px-4 py-2 rounded-md text-sm font-medium mb-2 ${
                  activeCategory === category
                    ? 'bg-yellow-600 text-white'
                    : 'bg-gray-800 text-gray-400 hover:text-white'
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* News Content */}
      {/* (rest of component code...) */}
    </div>
  );
}

export default NewsPage;
